import SwiperDiv from "../SwiperDiv"
import SwiperCarrossel from "../SwiperCarrossel"
import * as S from "./style"
import Button from "../Button";
import ContentHeadline from "../ContentHeadline";
import Copyline from "../Copyline"
import Vsl from "../Vsl";
export default function Main({ price, link }) {
    return (
        <div>
            <S.Container>
            <S.Versiculo>
                    <p>
                        Se tudo que você aprendeu sobre sedução foi com homens, eu sinto muito, mas você está condenado ao fracasso
                        </p>
        </S.Versiculo>
            {/* <Copyline>Essa plataforma é chave para você <span className="yellow">introduzir o amor de Cristo</span>,  no coração do seu filho</Copyline> */}
            <svg className="curve" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                <path fill="#191919" fillOpacity="1" d="M0,224L720,288L1440,224L1440,320L720,320L0,320Z"></path>
                    </svg>
            </S.Container>
            <S.ModulosContainer>
                <h1>Conteúdo: </h1>
                <SwiperDiv></SwiperDiv>
            </S.ModulosContainer>
            <S.Bonus>
                <h1>Bônus:</h1>
                <ContentHeadline emoji="🎭" text="O Poder do Mistério - Desvendando a Arte de Deixar as Mulheres Intrigadas"/>
                <ContentHeadline emoji="🕺🏻" text="A Dança do Magnetismo - Ser Você Mesmo Faz Toda a Diferença no Amor"/>
                <ContentHeadline emoji="📖" text="Decifrando as Entrelinhas - A Arte da Leitura de Segunda Camada nas Relações"/>
                <ContentHeadline emoji="🪄" text="Exemplos Práticos - Como Aplicar os Truques Psicológicos em Situações do Dia a Dia"/>
                <ContentHeadline emoji="🧙🏻‍♂️" text="Transfomando Truques em REALIDADE"/>
            </S.Bonus>
            <S.Audio>
                <p className="tituloParagrafo">Veja como <span className="vermelho">homens comuns se tornaram homens dominantes</span> e estão tendo resultados com mulheres de alto valor:</p>
                <SwiperCarrossel/>
                    {/* <h1>Conheça a plataforma por dentro</h1>
                    <img src="images/streming.webp" alt="" />
                    <p>Você receberá o conteúdo em vídeos, tudo isso na palma da sua mão quando e onde você quiser pelo seu <strong>Celular, TV, Tablet ou no Computador</strong></p> */}
            </S.Audio>
            <S.CopyHeadline>
                    <p>
                    Imagine a Mulher que você deseja, o livro será o veículo que fará Ela se interessar verdadeiramente e ir até você
                        </p>
        </S.CopyHeadline>
            <S.Copy>
                <h1>Você não precisa mais:</h1>
                <div className="teste">
                <div className="CopyContainer">
                    <div className="icon">⚠️</div>
                    <p className="conteudo">Correr atrás de uma mulher e ser completamente ignorado por ela</p>
                </div>
                <div className="CopyContainer">
                    <div className="icon">⚠️</div>
                    <p className="conteudo">Ser a segunda, terceira ou quarta opção de uma mulher</p>
                </div>
                <div className="CopyContainer">
                    <div className="icon">⚠️</div>
                    <p className="conteudo">Levar um fora de uma mulher que achou atraente</p>
                </div>
                <div className="CopyContainer">
                    <div className="icon">⚠️</div>
                    <p className="conteudo">Conhecer uma mulher legal e do nada ela sumir</p>
                </div>
                </div>
            </S.Copy>
            <S.Versiculo>
                <h1>Pra quem não tem tempo de ler</h1>
                <img src="/images/audiobook.jpg" alt="" />
                    <p className="audiolivro">
                    Absorva todo o conhecimento do nosso livro, mesmo nos dias mais corridos! Oferecemos de forma <strong>GRATUITA O AUDIOLIVRO</strong> para você aprender em qualquer lugar, sem comprometer sua rotina. Não deixe a falta de tempo limitar seu crescimento pessoal!
                </p>
        </S.Versiculo>
            {/* <S.Container>
            <Copyline>IMAGINE SEU FILHO crescendo em estatura e ao mesmo tempo sendo edificado em <span className="yellow">moral ética e fé</span></Copyline>
            </S.Container> */}
            
            <S.SellBoxContainer id="ancora">
            <div class="sellBox">
                <h1 className="headline">chegou a hora de se tornar um homem dominante!</h1>
                <img class="ebook" src="images/ebook.png" alt=""/>
			    <img class="logoSell" src="images/logo.png" alt=""/>
			    {/* <img class="logoSell" src="images/logowebapp.webp" alt=""/> */}
			    <p className="precoantigo">DE <span className="desconto">R$59,90</span> POR APENAS:</p>
			    <p class="preco">R${price} <span>à vista</span></p>
                <div className="paddingButton">
                    <Button class="test"nome={"quero adquirir os truques agora"} url={link} />
                </div>
			    <img class="pgto" src="images/pgto.webp" alt=""/>
		    </div>
            </S.SellBoxContainer>
        </div>
    )
}